
export const SET_LIST_TYPE = 'SET_LIST_TYPE';

export const LIST_TYPES = {
  LIST: 'list',
  GRID: 'grid',
};

export function setListType(listType) {
  return {
    type: SET_LIST_TYPE,
    payload: listType,
  };
}
